import { pubsub } from '@services';
import { notyf } from '@modules';

class QuantityInput extends HTMLElement {
  #input = this.querySelector('input');
  #buttons = this.querySelectorAll('button');

  connectedCallback() {
    this.#buttons.forEach((button) => {
      button.addEventListener('click', (event) => this.#handleStep(event.currentTarget.name));
    });

    this.#input.addEventListener('change', () => {
      this.#constrainAndUpdateInput(this.#input.value);
      this.#publishQuantityChange();
    });
  }

  /**
   * Handle the step up or step down of the quantity
   * @param {string} type - The type of step to be taken
   */
  #handleStep(type) {
    const value = parseInt(this.#input.value);
    const step = parseInt(this.#input.step) || 1;
    const newValue = type === 'minus' ? Math.max(value - step, 0) : value + step;
    const updatedValue = this.#constrainAndUpdateInput(newValue);

    if (parseInt(updatedValue) !== parseInt(value)) this.#publishQuantityChange();
  }

  /**
   * Constrain and update the input.
   * @param {number} newValue - The new value.
   * @returns {number} The constrained value.
   */
  #constrainAndUpdateInput(newValue) {
    const { min, max } = this.#input;
    this.#input.value = newValue;

    if (newValue >= max && max !== '') {
      notyf.error(window.toast_translations.product.quantity_error_max.replace('{{ max }}', max));
      this.#input.value = max;
    } else if (newValue <= min) this.#input.value = min;

    return this.#input.value;
  }

  #publishQuantityChange() {
    pubsub.publish('quantity:change', {
      line: this.dataset?.itemIndex,
      quantity: this.#input.value,
    });
  }
}

customElements.define('quantity-input', QuantityInput);
